<template>
  <div>
    <gg-card>
      <gg-card-header>
        Request Profile Removal
      </gg-card-header>
      <gg-card-text>
        <h4>Right To Erasure</h4>
        <p>Request your profile be permanently removed from our systems.</p>
        <gg-btn secondary :loading="loading" class="ml-0" @click="requestAccountClosure">
          Request Account Closure
          <span class="visually-hidden text-lowercase">button</span>
        </gg-btn>
      </gg-card-text>
    </gg-card>

<!--    <gg-modal :is-active="modal" max-width="350" @close="cancel">-->
<!--      <template v-slot:title>-->
<!--        Removal Request Assistance-->
<!--      </template>-->
<!--      <template v-slot:body>-->
<!--        There was a problem submitting your profile erasure request. Would you like to open a ticket for assistance?-->
<!--      </template>-->
<!--      <template v-slot:actions>-->
<!--        <gg-btn secondary @click="cancel">-->
<!--          No-->
<!--        </gg-btn>-->
<!--        <gg-btn primary @click="openTicket">-->
<!--          Yes-->
<!--        </gg-btn>-->
<!--      </template>-->
<!--    </gg-modal>-->
    <!-- Removal disabled, active services still exist -->
    <gg-modal v-if="removalPossible === false" :is-active="modal" max-width="350" @close="cancel">
      <template v-slot:title>
        Profile Removal Failed
      </template>
      <template v-slot:body>
        <template v-if="reasons.length === 0">
          Unfortunately your account is not eligible for profile removal. You may <router-link :to="{ name: 'support_ticketnew', query: { d: 'Support', s: 'other', sbj: 'Profile Removal Request' } }">open a ticket</router-link> for assistance.
        </template>
        <template v-else>
          Your profile is not eligible for removal because of the following reasons:
          <p v-for="(reason, i) in reasons" :key="`${i}-rsn`" class="mb-0">
            {{ reason }}
          </p>
          <br/>
          <p>You may <b><router-link :to="{ name: 'support_ticketnew', query: { d: 'Support', s: 'other', sbj: 'Profile Removal Request' } }">open a ticket</router-link></b> for assistance.</p>
        </template>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="cancel">
          Close
        </gg-btn>
      </template>
    </gg-modal>
    <!-- Removal confirmation dialog -->
    <gg-modal v-else-if="removalPossible === true" :is-active="modal" max-width="550" @close="cancel">
      <template v-slot:toolbar>
        Profile Removal Confirmation
      </template>
      <template v-slot:body>
        Your account is eligible for profile removal. Would you like to proceed?
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="cancel">
          No
          <span class="visually-hidden text-lowercase">
            button
        </span>
        </gg-btn>
        <gg-btn :loading="loadingRemove" primary @click="removeAccount">
          Yes
          <span class="visually-hidden text-lowercase">
            button
        </span>
        </gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RequestProfileRemove',
  data: () => ({
    removalPossible: null,
    loading: false,
    loadingRemove: false,
    reasons: [],
    modal: false
  }),
  methods: {
    ...mapActions(['profileRemove', 'makecall', 'clearStore', 'reportSuccess', 'reportError']),
    async requestAccountClosure () {
      this.loading = true
      const data = {
        method: 'gdpr_remove_profile'
      }
      try {
        const response = await this.makecall(data)
        this.removalPossible = response.removalPossible
        if (response.errors && Array.isArray(response.errors)) {
          this.reasons = response.errors
        }
        this.modal = true
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    async removeAccount () {
      this.loadingRemove = true
      const data = {
        method: 'gdpr_remove_profile',
        data: {
          confirmRemoval: 1
        }
      }
      try {
        const response = await this.makecall(data)
        this.reportSuccess(response.resultmsg)
        this.modal = false
        this.clearStore()
        this.$router.push({ name: 'login' })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingRemove = false
      }
    },
    cancel () {
      this.removalPossible = null
      this.modal = false
    },
    openTicket () {
      this.$router.push({
        name: 'support_ticketnew',
        query: {
          sbj: 'GDPR Profile Erasure Assistance',
          msg: 'Assistance is required after a problem submitting a profile erasure request.'
        }
      })
    }
  }
}
</script>
